module.exports = __webpack_public_path__ + "img/exhibition_on.188a29ca.png";